<template>
  <v-list-item class="player-item pl-0">
    <v-list-item-content>
      <v-list-item-title class="headline">
        {{ `${content.name} : ${content.value}` }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>


<script>
export default {
  name: "PlayerItem",
  props: ["content"]
};
</script>

<style scoped lang="scss">
.player-item {
  flex: auto !important;
  width: 33% !important;
}
</style>